import {createSelector} from 'reselect';
import {
    getBookingType,
    getHostType,
    getListingIds,
    getPricingBadges,
    getRankedBadges
} from './listing';
import {getBrandId} from './system';
import {getTranslations} from './store';
import getListingSourceId from '../utils/getListingSourceId';

const getPremierPartnerBadge = createSelector(
    [getRankedBadges],
    (rankedBadges) => {
        const premierPartner = '1';
        const premierPartnerBadge = rankedBadges.find((badge) => badge.id === premierPartner);
        return premierPartnerBadge || {};
    }
);

const getInstallmentsBadge = createSelector(
    [getBookingType, getListingIds, getBrandId, getTranslations, getHostType],
    (bookingType, listingIds, brandId, translations, hostType) => {
        const HOMEAWAY_BR_ID = '126';
        const listingSourceSiteId = getListingSourceId(listingIds.listingId);
        const isBrazilSourceSite = listingSourceSiteId === HOMEAWAY_BR_ID;
        const isBrazil = brandId === HOMEAWAY_BR_ID;
        // TRAVSCI-538: hide installments for non-platform properties
        const isNotIPM = !hostType.ipm;
        if (isBrazil && isBrazilSourceSite && bookingType.onlineBookable && isNotIPM) {
            return {label: translations.installmentsBadge};
        }
        return {};
    }
);

const getNldBadge = createSelector(
    [getPricingBadges],
    (pricingBadges) => {
        if (pricingBadges.length === 0) {
            return {};
        }
        return pricingBadges[0];
    }
);

export {getPremierPartnerBadge, getInstallmentsBadge, getNldBadge};
